const snackbar = {
  snackbar: false,
  y: 'bottom',
  x: 'right',
  mode: 'multi-line',
  timeout: 6000,
  color: 'error',
  text: ''
};
const HttpErrorToSnackbar = (error) => {
  console.log(error);

  snackbar.text = '';
  if (error.response === undefined) {
    snackbar.snackbar = true;
    snackbar.color = 'red';
    snackbar.text = 'ناتوان در اتصال';
    return snackbar;
  }
  if (error.response.status === 422) {
    if (typeof error.response.data.message === 'undefined') {
      snackbar.text = 'سرور ناتوان در پردازش درخواست, فیلدهای ورودی را چک کنید.';
    } else {
      snackbar.text = error.response.data.message;
    }
  }
  if (error.response.status === 400 && typeof error.response.data.message !== 'undefined' && error.response.data.message.indexOf('jwt') > -1) {
    window.location.href = '#/login';
  }
  if (error.response.status === 412) {
    snackbar.text = error.response.data.message;
  }
  if (error.response.status === 404) {
    snackbar.text = 'صفحه یافت نشد.';
  }
  if (error.response.status === 401) {
    snackbar.text = 'اطلاعات ورودشما منقضی شده است. مجدداً وارد شوید.';
  }
  if (error.response.status === 403) {
    snackbar.text = 'به این قسمت دسترسی ندارید!';
  }
  if (error.response.status === 500) {
    snackbar.text = 'خطای سرور, ناتوان در انجام درخواست!';
  }
  if (error.response.status === 405) {
    snackbar.text = 'درخواست غیرمجاز است!';
  }
  if (snackbar.text === '' && typeof error.response.data.messages !== 'undefined') {
    snackbar.snackbar = false;
    if (error.response.data.messages !== null) {
      error.response.data.messages.forEach(function (v) {
        snackbar.text += v + ' ';
      });
    } else {
      snackbar.text = 'خطای نامشخص!';
    }
  }
  if (snackbar.text.length === 0 &&
    typeof error.response.data.message !== 'undefined' &&
    error.response.data.message.length > 0) {
    snackbar.text = error.response.data.message;
  }
  snackbar.snackbar = true;
  snackbar.color = 'red';
  return snackbar;
};
export default HttpErrorToSnackbar;



// WEBPACK FOOTER //
// ./src/api/HttpErrorToSnackbar.js